import { Modal, Image, Text, Button } from "@mantine/core";
import { modals } from "@mantine/modals";

interface ImageModalProps {
  title?: string;
  imageUrl: string;
  caption?: string;
  onClose?: () => void;
}

export const showImageModal = (props: ImageModalProps) => {
  const { title, imageUrl, caption, onClose } = props;

  modals.open({
    title: title || "Preview",
    centered: true,
    size: "lg",
    children: (
      <div className="flex flex-col items-center gap-3">
        <Image
          src={imageUrl}
          alt={title || "preview"}
          radius="md"
          fit="contain"
          maw={400}
        />
        {caption && (
          <Text size="sm" color="dimmed">
            {caption}
          </Text>
        )}
        <Button
          mt="md"
          color="gray"
          variant="light"
          fullWidth
          onClick={() => {
            modals.closeAll();
            onClose?.();
          }}
        >
          Close
        </Button>
      </div>
    ),
  });
};
